import * as React from 'react';

import {Stack} from 'shells/layout/stack/stack';
import {Modal} from 'shells/modal/modal';

import type {DocumentSourceTypeEnum} from 'nutshell-graphql-types';
import type {ChatSettingsKnowledgeFragment} from 'nutshell-graphql-types';

import {useGetContextDocuments} from '../../../graphql/hooks';

import {getContentPreviewSubheaderText} from '../../helpers';

import {AiSuggestionsContent} from './ai-suggestions-content';
import {ContentPreview} from './content-preview';
import {SelectedDocumentInfoRow} from './selected-document-info-row';

type Props = {
    documentId: string;
    sourceType: DocumentSourceTypeEnum;
    onClose: () => void;
    canToggle: boolean;
    chatSettings: ChatSettingsKnowledgeFragment | null | undefined;
};

export function SelectedDocumentModal(props: Props) {
    const {contextDocuments} = useGetContextDocuments(true, props.sourceType);
    const document = contextDocuments.find((doc) => doc && doc.id === props.documentId);

    if (!document) {
        return null;
    }

    const headerText = document.sourceType === 'WEB_PAGE' ? 'Webpage' : 'Document';

    return (
        <Modal
            isOpen={true}
            onClose={props.onClose}
            headerText={`${headerText} markup content`}
            headerSubtext={getContentPreviewSubheaderText(document)}
            fitHeight={true}
        >
            <Stack spacing={24}>
                <SelectedDocumentInfoRow document={document} canToggle={props.canToggle} />
                {props.chatSettings && props.chatSettings.lookAndFeel && (
                    <AiSuggestionsContent
                        lookAndFeel={props.chatSettings.lookAndFeel}
                        aiSuggestions={document.aiSuggestions}
                    />
                )}
                <ContentPreview document={document} />
            </Stack>
        </Modal>
    );
}
